/**
 * Panel Component
 *
 * Renders the appropriate entity panel based on selection.
 * Uses the new design system components.
 */

import { CompanyPanel } from './company/CompanyPanel';
import { LocationPanel } from './location/LocationPanel';
import { ResellerPanel } from './reseller/ResellerPanel';
import { EmployeePanel } from './employee/EmployeePanel';
import { SystemPanel } from './system/SystemPanel';
import { SystemSettingsPanel } from './systemSettings/SystemSettingsPanel';

import type { Operation } from '@/types/general';
import { Selection } from '../orgNavTypes';
import type { SelectionState } from '../useOrgNavState';
import { useOperation } from './useOperation';

type PanelProps = {
    selection: SelectionState;
    onSuccess: () => void;
};

export type ManageProps = {
    /**
     * ID must always be provided - even in create mode.
     * Prevents error possibilities +
     */
    operation: Operation;
    id?: number;
    /**
     * Perform operations in the parent component after the form is submitted successfully.
     */
    onSuccess: () => void;
};

const SELECTION_COMPONENTS = {
    [Selection.Company]: CompanyPanel,
    [Selection.Reseller]: ResellerPanel,
    [Selection.Location]: LocationPanel,
    [Selection.System]: SystemPanel,
    [Selection.SystemSettings]: SystemSettingsPanel,
    [Selection.Employee]: EmployeePanel as any,
};

export const Panel = ({ selection, onSuccess }: PanelProps) => {
    const Component = selection.type && SELECTION_COMPONENTS[selection.type];

    const operation = useOperation();

    return Component ? <Component operation={operation} id={selection.id!} onSuccess={onSuccess} /> : null;
};
